/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Reorder Icon component.
 */
export const SortDownIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.73987 12.333L9.02662 16.1382L13.1362 12.333" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.93372 3.76367V14.854" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
